<template>
  <section class="insights">
    <ul class="nav nav-pills">
      <li v-bind:class="{ active: activeInsightSection === 'bluffing' }">
        <a v-on:click="activeInsightSection = 'bluffing'">
          Bluffing
        </a>
      </li>
      <li v-bind:class="{ active: activeInsightSection === 'bluff raising' }">
        <a v-on:click="activeInsightSection = 'bluff raising'">
          Bluff raising
        </a>
      </li>
    </ul>
    <section v-if="activeInsightSection === 'bluffing'">
      <table class="table">
        <thead>
          <tr>
            <header-cell v-bind:profitable="isBluffProfitable(1, 3)">
              1/3 pot
            </header-cell>
            <header-cell v-bind:profitable="isBluffProfitable(1, 2)">
              1/2 pot
            </header-cell>
            <header-cell v-bind:profitable="isBluffProfitable(2, 3)">
              2/3 pot
            </header-cell>
            <header-cell v-bind:profitable="isBluffProfitable(3, 4)">
              3/4 pot
            </header-cell>
            <header-cell v-bind:profitable="isBluffProfitable(1, 1)">
              Full pot
            </header-cell>
            <header-cell v-bind:profitable="isBluffProfitable(3, 2)">
              1.5x pot
            </header-cell>
            <header-cell v-bind:profitable="isBluffProfitable(2, 1)">
              2x pot
            </header-cell>
          </tr>
        </thead>
        <tbody>
          <tr>
            <table-cell v-bind:profitable="isBluffProfitable(1, 3)">
              25%
            </table-cell>
            <table-cell v-bind:profitable="isBluffProfitable(1, 2)">
              33.3%
            </table-cell>
            <table-cell v-bind:profitable="isBluffProfitable(2, 3)">
              40%
            </table-cell>
            <table-cell v-bind:profitable="isBluffProfitable(3, 4)">
              42.9%
            </table-cell>
            <table-cell v-bind:profitable="isBluffProfitable(1, 1)">
              50%
            </table-cell>
            <table-cell v-bind:profitable="isBluffProfitable(3, 2)">
              60%
            </table-cell>
            <table-cell v-bind:profitable="isBluffProfitable(2, 1)">
              66.6%
            </table-cell>
          </tr>
        </tbody>
      </table>
    </section>
    <section v-if="activeInsightSection === 'bluff raising'" class="bluff-raising">
      <initial-bet-size-button-group
        v-bind:initialBetSize="initialBetSize"
        v-on:setInitialBetSize="initialBetSize = $event"
      />
      <table class="table">
        <thead>
          <tr>
            <header-cell v-bind:profitable="isRaiseProfitable(2)">
              2x initial bet
            </header-cell>
            <header-cell v-bind:profitable="isRaiseProfitable(3)">
              3x initial bet
            </header-cell>
            <header-cell v-bind:profitable="isRaiseProfitable(4)">
              4x initial bet
            </header-cell>
            <header-cell v-bind:profitable="isRaiseProfitable(5)">
              5x initial bet
            </header-cell>
            <header-cell v-bind:profitable="isRaiseProfitable(6)">
              6x initial bet
            </header-cell>
          </tr>
        </thead>
        <tbody>
          <tr>
            <table-cell v-bind:profitable="isRaiseProfitable(2)">
              {{ getPercentageOfTimeRaiseNeedsToWork(2).toFixed(0) }}%
            </table-cell>
            <table-cell v-bind:profitable="isRaiseProfitable(3)">
              {{ getPercentageOfTimeRaiseNeedsToWork(3).toFixed(0) }}%
            </table-cell>
            <table-cell v-bind:profitable="isRaiseProfitable(4)">
              {{ getPercentageOfTimeRaiseNeedsToWork(4).toFixed(0) }}%
            </table-cell>
            <table-cell v-bind:profitable="isRaiseProfitable(5)">
              {{ getPercentageOfTimeRaiseNeedsToWork(5).toFixed(0) }}%
            </table-cell>
            <table-cell v-bind:profitable="isRaiseProfitable(6)">
              {{ getPercentageOfTimeRaiseNeedsToWork(6).toFixed(0) }}%
            </table-cell>
          </tr>
        </tbody>
      </table>
    </section>
    <hr>
  </section>
</template>

<script>
import HeaderCell from '@/components/hit-calculator/five-card-hands-section/insights/header-cell';
import TableCell from '@/components/hit-calculator/five-card-hands-section/insights/table-cell';
import InitialBetSizeButtonGroup from '@/components/hit-calculator/five-card-hands-section/insights/initial-bet-size-button-group';

export default {
  name: 'hit-calculator-insights',
  components: {
    'header-cell': HeaderCell,
    'table-cell': TableCell,
    'initial-bet-size-button-group': InitialBetSizeButtonGroup,
  },
  props: ['hitPercentage', 'hitPercentageUpToDate'],
  data: function () {
    return {
      initialBetSize: '1/2 pot',
      activeInsightSection: 'bluffing',
    };
  },
  methods: {
    isBluffProfitable: function (risk, reward) {
      let hasSimulationBeenRun = true; // TODO

      if (!hasSimulationBeenRun || !this.hitPercentageUpToDate) {
        return null;
      }

      let percentageOfTimeBluffWorks = 100 - Number(this.hitPercentage);
      let percentageOfTimeBluffNeedsToWork = this._getPercentageOfTimeBluffNeedsToWork(risk, reward);
      return percentageOfTimeBluffWorks > percentageOfTimeBluffNeedsToWork;
    },
    _getPercentageOfTimeBluffNeedsToWork: function (risk, reward) {
      return (risk / (risk + reward)) * 100;
    },
    isRaiseProfitable: function (timesInitialBet) {
      let hasSimulationBeenRun = true; // TODO

      if (!hasSimulationBeenRun || !this.hitPercentageUpToDate) {
        return null;
      }

      let percentageOfTimeRaiseWorks = 100 - Number(this.hitPercentage);
      let percentageOfTimeRaiseNeedsToWork = this.getPercentageOfTimeRaiseNeedsToWork(timesInitialBet);
      return percentageOfTimeRaiseWorks > percentageOfTimeRaiseNeedsToWork;
    },
    getPercentageOfTimeRaiseNeedsToWork: function (timesInitialBet) {
      let initialBet;
      let risk;
      let reward;
      let raiseSize;

      if (this.initialBetSize === '1/2 pot') {
        initialBet = 0.5;
      } else if (this.initialBetSize === '3/4 pot') {
        initialBet = 0.75;
      } else if (this.initialBetSize === 'Full pot') {
        initialBet = 1;
      } else {
        throw new Error('initialBetSize has an invalid value: ', this.initialBetSize)
      }

      raiseSize = initialBet * timesInitialBet;
      risk = raiseSize - initialBet;
      reward = 1 + (initialBet * 2);
      return ((risk / (risk + reward)) * 100).roundToTwoDecimalPlaces();
    },
  },
}
</script>

<style lang="scss" scoped>
  .nav-pills {
    margin-bottom: 15px;

    a {
      cursor: pointer;
    }
  }

  .bluff-raising table {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/hit-calculator/five-card-hands-section/insights/insights.vue